import { render, staticRenderFns } from "./language-dropdown.vue?vue&type=template&id=5f7f0daa&scoped=true"
import script from "./language-dropdown.vue?vue&type=script&lang=js"
export * from "./language-dropdown.vue?vue&type=script&lang=js"
import style0 from "./language-dropdown.vue?vue&type=style&index=0&id=5f7f0daa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7f0daa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f7f0daa')) {
      api.createRecord('5f7f0daa', component.options)
    } else {
      api.reload('5f7f0daa', component.options)
    }
    module.hot.accept("./language-dropdown.vue?vue&type=template&id=5f7f0daa&scoped=true", function () {
      api.rerender('5f7f0daa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/language-dropdown.vue"
export default component.exports